export default __webpack_public_path__ + "static/media/top_design.1201f9dc.png";